export default "__VITE_ASSET__DNJdBMtI__"